import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import EditPartnershipForm from './EditPartnershipForm'
import FormDrawerWrapper from '../../../../../features/components/FormDrawerWrapper'
import SkeletonSingleSectionForm from '../../../../../features/components/FormDrawerWrapper/Skeletons/SkeletonSingleSectionForm'

import useAdditionalPartnershipsData from '../hooks'
import useManageDrawer from '../../../../../hooks/formHooks/useManageDrawer'

import { partnershipsSelector } from '../../../../../modules/selectors/partnerships'

import { PARTNERSHIP_EDIT } from '../../../../../constants/forms'

const EditPartnership = () => {
  const partnerships = useSelector(partnershipsSelector)

  const { selectedEditItemId } = useManageDrawer({ formName: PARTNERSHIP_EDIT })

  const isInitialDataLoading = useAdditionalPartnershipsData(PARTNERSHIP_EDIT)

  const editPartnershipData = useMemo(
    () => partnerships.find(partnership => partnership.id === parseInt(selectedEditItemId)),
    [partnerships, selectedEditItemId]
  )

  return (
    <FormDrawerWrapper
      formName={PARTNERSHIP_EDIT}
      SkeletonFormComponent={SkeletonSingleSectionForm}
      title="Edit a partnership"
      isFormLoading={!editPartnershipData || isInitialDataLoading}
      showOpenButton={false}
    >
      <EditPartnershipForm />
    </FormDrawerWrapper>
  )
}

export default EditPartnership
